import { AxiosRequestConfig } from 'axios'
import { useApi } from '../hooks'
import {
  Aurora,
  AuroraAwhpData,
  AuroraAwhpDataQuery,
  AuroraAwhpEvent,
  AuroraAwhpEventQuery
} from '../types'
import { subMinutes } from 'date-fns'
import AuroraAwhpActionInput from '../types/AuroraAwhpActionInput'
import {
  AuroraCirculationPumpMode,
  AuroraCirculationPumpStatus,
  AuroraHeatPumpStatus
} from '../enums'

const api = useApi('v2')

export async function getAuroras(config?: AxiosRequestConfig) {
  const response = await api.get<Aurora[]>('/auroras', config)

  return response.data
}

export async function getAurora(id: string, config?: AxiosRequestConfig) {
  const response = await api.get<Aurora>(`/auroras/${id}`, config)

  return response.data
}

export async function getAuroraAwhpData(
  query: AuroraAwhpDataQuery,
  config?: Omit<AxiosRequestConfig, 'params'>
) {
  const response = await api.get<AuroraAwhpData[]>(`/auroras/awhp-data`, {
    params: query,
    ...config
  })

  return response.data
}

export async function getAuroraAwhpDataNow(
  id: string,
  config?: Omit<AxiosRequestConfig, 'params'>
) {
  const response = await api.get<AuroraAwhpData[]>(`/auroras/${id}/awhp-data`, {
    ...config,
    params: {
      aurora_id: id,
      from: subMinutes(new Date(), 3),
      to: new Date()
    }
  })

  if (response.data.length === 0) {
    throw new Error()
  }

  return response.data[0]
}

export async function getAuroraAwhpEvents(
  query: AuroraAwhpEventQuery,
  config?: Omit<AxiosRequestConfig, 'params'>
) {
  const response = await api.get<AuroraAwhpEvent[]>(`/auroras/awhp-events`, {
    params: query,
    ...config
  })

  return response.data
}

export async function publishAuroraAwhpAction(
  id: string,
  action: AuroraAwhpActionInput,
  config?: AxiosRequestConfig
) {
  await api.post(`/auroras/${id}/awhp/action`, action, config)
}

export async function setAuroraHeatPumpStatus(
  id: string,
  status: AuroraHeatPumpStatus,
  config?: AxiosRequestConfig
) {
  await publishAuroraAwhpAction(
    id,
    {
      hp: {
        system_on: status
      }
    },
    config
  )

  // TODO: Confirm the action.
  await wait(3000)
}

export async function setAuroraHeatPumpTargetTemperature(
  id: string,
  temperature: number,
  config?: AxiosRequestConfig
) {
  await api.post(
    `/auroras/${id}/awhp/action`,
    {
      hp: {
        setTarget1: temperature
      }
    },
    config
  )

  // TODO: Confirm the action.
  await wait(3000)
}

export async function setAuroraCirculatorPumpStatus(
  id: string,
  status: AuroraCirculationPumpStatus,
  config?: AxiosRequestConfig
) {
  await publishAuroraAwhpAction(
    id,
    {
      pump: {
        run: status
      }
    },
    config
  )

  // TODO: Confirm the action.
  await wait(3000)
}

export async function setAuroraCirculationPumpMode(
  id: string,
  mode: AuroraCirculationPumpMode,
  config?: AxiosRequestConfig
) {
  await publishAuroraAwhpAction(
    id,
    {
      pump: {
        mode
      }
    },
    config
  )

  // TODO: Confirm the action.
  await wait(3000)
}

export async function getAuroraAwhpActiveEvents(id: string, config?: AxiosRequestConfig) {
  const response = await api.get<AuroraAwhpEvent[]>(`/auroras/${id}/awhp/active-events`, config)

  return response.data
}

async function wait(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}
